import React from 'react';
import classNames from 'classnames';
import highlightText from 'utils/highlightText';
import styles from './AssignedOutletsSection.css';

/*
 * Recommend to move some states into this component (e.g. selection state, filter)
 * so that the parent can treat this like a black box.
 */
function AssignedOutletsSection(props) {
  const {
    assignedOutlets,
    onClickOutlet,
    selectedOutlets,
    onNameFilterChange,
    nameFilter,
  } = props;

  const effectiveFilter = nameFilter.trim();
  const filteredOutlets = assignedOutlets.filter(({ outlet_name: name }) =>
    name.toLowerCase().match(effectiveFilter.toLowerCase())
  );

  return (
    <div>
      <div className={styles.outletsContainer}>
        <div className={styles.search}>
          <i className={classNames('fa fa-search', styles.iconSearch)} />
          <input
            type="text"
            placeholder="Search"
            className={classNames('form-control', styles.textSearch)}
            onChange={e => onNameFilterChange(e.target.value)}
            value={nameFilter}
          />
          {nameFilter && (
            <i
              className={classNames('fa fa-times', styles.iconClearFilter)}
              onClick={() => onNameFilterChange('')}
            />
          )}
        </div>
        <div className={styles.outletRows}>
          <table className={styles.outletTable}>
            <tbody>
              {filteredOutlets.map((outlet, idx) => (
                <tr
                  key={outlet.outlet_id}
                  onClick={e =>
                    onClickOutlet(outlet, idx, {
                      ctrlPressed: e.metaKey || e.ctrlKey,
                      shiftPressed: e.shiftKey,
                    })
                  }
                  className={
                    selectedOutlets.length > 0 &&
                    selectedOutlets.includes(outlet) &&
                    styles.outletSelected
                  }
                >
                  <td className={styles.outletName}>
                    {highlightText(outlet.outlet_name, effectiveFilter)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {selectedOutlets.length > 0 && (
        <div className={styles.totalSelected}>
          Selected: <b>{selectedOutlets.length} outlets</b>
        </div>
      )}
      {selectedOutlets.length === 0 && (
        <div className={styles.totalSelected}>
          Total: <b>{filteredOutlets.length} outlets</b>
        </div>
      )}
    </div>
  );
}

AssignedOutletsSection.defaultProps = {
  assignedOutlets: [],
};

export default AssignedOutletsSection;
